import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import steps from './comp/steps.vue';
import orderNum from './comp/orderNum.vue';
import orderUsp from './comp/orderUsp.vue';
import orderTaber from './comp/orderTaber.vue';
export default {
  meta: {
    title: '订单详情',
    auth: true,
    authorityValue: 'store-order-management'
  },
  name: 'orderDetail',
  components: {
    steps: steps,
    orderNum: orderNum,
    orderUsp: orderUsp,
    orderTaber: orderTaber
  },
  data: function data() {
    return {
      tableData: [],
      total: 0,
      showSteps: true
    };
  },
  created: function created() {
    var query = this.$route.query;
    this.dataBind(query);
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.orderDetails(_objectSpread({}, item));

              case 2:
                res = _context.sent;
                _this.tableData = res;

                if (!(_this.tableData.orderStatus == 6 || _this.tableData.orderStatus == 7 || _this.tableData.orderStatus == 8)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", _this.showSteps = false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSearch: function handleSearch(item) {
      console.log(item);
    },
    handleNav: function handleNav(NAME) {
      this.$router.push({
        name: NAME
      });
    },
    confirm: function confirm() {}
  }
};